import React from 'react'
import { ReactComponent as SadEmoji } from 'assets/svg/emojis/emoji-sad.svg'
import { NoAssetsTitle, RedirectText } from './styled'

const Noaccount = ({ message }: { message: string }) => {
  return (
    <div style={{ textAlign: 'center', fontFamily: 'Rubik' }}>
      <SadEmoji />
      <NoAssetsTitle>{message}</NoAssetsTitle>
      <RedirectText>Click the connect button on the top right of the page</RedirectText>
    </div>
  )
}

export default Noaccount
